export default __webpack_public_path__ + "static/media/pine-logo.e77aeba4.svg";